(() => {
  if (!customElements.get('mn-account-password')) {
    customElements.define('mn-account-password', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        if (!this.input || !this.button || this.onToggle) return;
        this.onToggle = () => {
          const show = this.input.type === 'password';
          this.input.type = show ? 'text' : 'password';
          this.button.setAttribute('aria-pressed', String(show));
          this.button.setAttribute('aria-label', show ? this.button.dataset.hideLabel : this.button.dataset.showLabel);
          this.button.textContent = show ? this.button.dataset.hideText : this.button.dataset.showText;
        };
        this.button.setAttribute('aria-controls', this.input.id);
        this.button.addEventListener('click', this.onToggle);
        this.button.hidden = false;
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
        this.onToggle = null;
      }
    });
  }

  if (!customElements.get('mn-account-motion')) {
    customElements.define('mn-account-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        const account = this.closest('account-login');
        if (!account) return;
        this.views = [account.querySelector('#login'), account.querySelector('#recover')].filter(Boolean);
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.adjustMotion = () => {
          for (const view of this.views) {
            for (const animation of view.getAnimations()) {
              if (animation.playState !== 'running') continue;
              if (this.preference.matches) animation.finish();
              else animation.updatePlaybackRate(2.5);
            }
          }
        };
        this.onHashChange = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.adjustMotion);
        };
        this.observer = new MutationObserver(() => {
          this.adjustMotion();
          const visible = this.views.find(view => !view.hidden);
          visible?.querySelector('h1')?.focus({ preventScroll: true });
        });
        for (const view of this.views) this.observer.observe(view, { attributes: true, attributeFilter: ['hidden'] });
        window.addEventListener('hashchange', this.onHashChange);
        this.preference.addEventListener('change', this.adjustMotion);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
        window.removeEventListener('hashchange', this.onHashChange);
        this.preference?.removeEventListener('change', this.adjustMotion);
      }
    });
  }
})();
